<template>
    <component :is="pageComponent"
               :data="data"
               :columns="columns"
               :model="$route.params.resource"
               pagination-route="model.action"
               :pagination-endpoint="paginationEndpoint"
    ></component>
</template>

<script>
    export default {
        data() {
            return {
                loading: true,
                data: {},
                columns: [],
                pageComponent: null
            }
        },
        created() {
            const routeParams = this.$route.params;
            this.loadComponent(routeParams);
        },
        methods: {
            loadComponent(routeParams) {
                if (
                    this.$modelComponents.hasOwnProperty(routeParams.resource) &&
                    this.$modelComponents[routeParams.resource].hasOwnProperty(routeParams.action)
                ) {
                    this.pageComponent = this.$modelComponents[routeParams.resource][routeParams.action];
                } else {
                    if (routeParams.action === 'index') {
                        this.pageComponent = 'ModelTable'
                    } else {
                        this.pageComponent = 'NotFoundPage'
                    }
                }
            }
        },
        computed: {
            paginationEndpoint() {
                return '/' + this.$route.params.resource + '/' + this.$route.params.action
            }
        },
        watch: {
            $route(to) {
                this.loadComponent(to.params);
            }
        }
    }
</script>
